<script>
import StakeholderCategoryService from "@/services/StakeholderCategoryService";
import Cloner from "@/libraries/Cloner";

export default {
    props: {
        stakeholderCategoryId: {}
    },
    data() {
        return {
            loading: true,
            errors: {},
            entity: {
                id: null,
                name: null
            }
        };
    },
    async created() {
        await this.fetchData();
        this.loading = false;
    },
    mounted() {
        this.$nextTick(() => {
            const input = this.$refs.firstInput?.$el.querySelector("input");
            if (input) input.focus();
        });
    },
    methods: {
        async fetchData() {
            try {
                const { data } = await StakeholderCategoryService.GETS(
                    this.stakeholderCategoryId
                );
                this.entity = Cloner.pickClone(data.data, ["id", "name"]);
            } catch (e) {
                console.log("exc fetch data", e);
            }
        },
        async saveForm() {
            try {
                await StakeholderCategoryService.PUT(this.entity);
                this.$emit("close-renamed", { name: this.entity.name });
            } catch (e) {
                this.errors = e.response.data.errors;
            }

            this.saving = false;
        }
    }
};
</script>

<template>
    <modal
        :show="true"
        @close="$emit('close')"
        class="budget-modal"
        :loading="loading"
    >
        <template slot="header">
            {{ $t("stakeholders.edit_group") }}
        </template>

        <template slot="default">
            <FormulateForm v-model="entity" @submit="saveForm" :errors="errors">
                <div class="row">
                    <div class="col-12">
                        <FormulateInput
                            type="text"
                            ref="firstInput"
                            name="name"
                            :label="$t('stakeholders.group_name')"
                            :validation-name="$t('stakeholders.group_name')"
                            validation="required"
                        />
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col text-right">
                        <base-button
                            type="secondary"
                            :outline="true"
                            @click="$emit('close')"
                            >{{ $t("cancel") }}</base-button
                        >
                        <base-button
                            type="primary"
                            :loading="saving"
                            native-type="submit"
                            >{{ $t("save") }}</base-button
                        >
                    </div>
                </div>
            </FormulateForm>
        </template>
    </modal>
</template>
